import React, { useState } from 'react';
import { collection, writeBatch, doc, getDocs, query, where, deleteDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const FAKE_GROUP_ID = 'demo-pitazo-mundial-2026';
const FAKE_USER_IDS = ['u1','u2','u3','u4','u5','u6','u7','u8','u9','u10'];
const FINISHED_FIXTURE_IDS = ['A1','A2','B1','D1','B2','C1','C2','E1','F1','H1'];

export default function DemoCleanPage() {
  const [status, setStatus] = useState('idle');
  const [log, setLog] = useState([]);
  const [confirm, setConfirm] = useState(false);

  function addLog(msg) {
    setLog(prev => [...prev, msg]);
  }

  async function runClean() {
    setStatus('loading');
    setLog([]);
    try {
      // 1. Borrar predicciones del grupo demo
      addLog('🗑️ Borrando predicciones demo...');
      const predsQ = query(collection(db, 'predictions'), where('groupId', '==', FAKE_GROUP_ID));
      const predsSnap = await getDocs(predsQ);
      const batch1 = writeBatch(db);
      predsSnap.docs.forEach(d => batch1.delete(d.ref));
      await batch1.commit();
      addLog(`   → ${predsSnap.size} predicciones borradas`);

      // 2. Borrar miembros del grupo
      addLog('👥 Borrando miembros...');
      const membersSnap = await getDocs(collection(db, 'groups', FAKE_GROUP_ID, 'members'));
      const batch2 = writeBatch(db);
      membersSnap.docs.forEach(d => batch2.delete(d.ref));
      await batch2.commit();
      addLog(`   → ${membersSnap.size} miembros borrados`);

      // 3. Borrar el grupo
      addLog('📁 Borrando grupo demo...');
      await deleteDoc(doc(db, 'groups', FAKE_GROUP_ID));
      addLog('   → Grupo borrado');

      // Limpiar groupIds del usuario real
      await updateDoc(doc(db, 'users', 'wMo1uORIf2Q2g2P9qJJb0mQSsk13'), { groupIds: [] });
      addLog('   → Usuario limpiado');

      // 4. Revertir partidos a estado upcoming
      addLog('⚽ Revirtiendo resultados de partidos...');
      const batch3 = writeBatch(db);
      FINISHED_FIXTURE_IDS.forEach(id => {
        const ref = doc(db, 'fixtures', id);
        batch3.update(ref, {
          homeScore: null,
          awayScore: null,
          status: 'upcoming',
        });
      });
      await batch3.commit();
      addLog(`   → ${FINISHED_FIXTURE_IDS.length} partidos revertidos a "upcoming"`);

      addLog('✅ ¡Base de datos limpia! La app queda como nueva.');
      setStatus('done');
    } catch (e) {
      addLog('❌ Error: ' + e.message);
      setStatus('error');
    }
  }

  const s = {
    page: { minHeight: '100vh', background: '#080810', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Oswald',sans-serif", padding: 20 },
    card: { background: '#14141f', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '2rem', maxWidth: 420, width: '100%', color: '#F5F5F0' },
  };

  return (
    <div style={s.page}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@700&family=Inter:wght@400&display=swap');`}</style>
      <div style={s.card}>
        <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 12 }}>🧹</div>
        <div style={{ fontSize: 18, letterSpacing: 2, textAlign: 'center', marginBottom: 4 }}>LIMPIEZA DEMO</div>
        <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#6B6B7B', textAlign: 'center', marginBottom: 20 }}>
          Borra todos los datos demo y deja la base de datos limpia.<br />
          <strong style={{ color: '#E63946' }}>Esta acción no se puede deshacer.</strong>
        </div>

        {log.length > 0 && (
          <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: 10, padding: '12px 14px', marginBottom: 16, maxHeight: 200, overflowY: 'auto' }}>
            {log.map((l, i) => (
              <div key={i} style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#aaa', marginBottom: 4 }}>{l}</div>
            ))}
          </div>
        )}

        {!confirm && status === 'idle' ? (
          <button onClick={() => setConfirm(true)}
            style={{ width: '100%', padding: 14, background: 'rgba(230,57,70,0.15)', border: '1px solid rgba(230,57,70,0.3)', borderRadius: 10, fontFamily: "'Oswald',sans-serif", fontSize: 14, fontWeight: 700, color: '#E63946', cursor: 'pointer', letterSpacing: 2 }}>
            🧹 LIMPIAR BASE DE DATOS
          </button>
        ) : status === 'idle' ? (
          <div>
            <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#F0B429', textAlign: 'center', marginBottom: 14 }}>
              ¿Seguro? Esto borrará el grupo demo, los 10 usuarios y revertirá los partidos.
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setConfirm(false)}
                style={{ flex: 1, padding: 12, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, color: '#aaa', fontFamily: "'Oswald',sans-serif", fontSize: 13, cursor: 'pointer' }}>
                CANCELAR
              </button>
              <button onClick={runClean}
                style={{ flex: 1, padding: 12, background: '#E63946', border: 'none', borderRadius: 10, fontFamily: "'Oswald',sans-serif", fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer', letterSpacing: 1 }}>
                SÍ, LIMPIAR
              </button>
            </div>
          </div>
        ) : (
          <button disabled
            style={{ width: '100%', padding: 14, background: status === 'done' ? 'rgba(6,184,106,0.15)' : '#333', border: `1px solid ${status === 'done' ? 'rgba(6,184,106,0.3)' : 'transparent'}`, borderRadius: 10, fontFamily: "'Oswald',sans-serif", fontSize: 14, color: status === 'done' ? '#06B86A' : '#555', letterSpacing: 2 }}>
            {status === 'loading' ? 'LIMPIANDO...' : '✅ BASE LIMPIA'}
          </button>
        )}
      </div>
    </div>
  );
}